import { STRING_getInstance2ou4lro9xn2qn as STRING_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import {
  Companion_getInstance3qu5ydsg8audm as Companion_getInstance,
  TimeZone3oibfp0mqo4lg as TimeZone,
  FixedOffsetTimeZone3oldrgkltiv4z as FixedOffsetTimeZone,
} from '../TimeZone.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  Companion_getInstance3p275ab8rhrps as Companion_getInstance_0,
  UtcOffset17lxgyhnn4rny as UtcOffset,
} from '../UtcOffset.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var TimeZoneSerializerClass;
function TimeZoneSerializer() {
  if (TimeZoneSerializerClass === VOID) {
    class $ {
      constructor() {
        TimeZoneSerializer_instance = this;
        this.b26_1 = PrimitiveSerialDescriptor('kotlinx.datetime.TimeZone', STRING_getInstance());
      }
      az() {
        return this.b26_1;
      }
      pz(decoder) {
        return Companion_getInstance().d26(decoder.h13());
      }
      e26(encoder, value) {
        encoder.p14(value.g26());
      }
      oz(encoder, value) {
        return this.e26(encoder, value instanceof TimeZone() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'TimeZoneSerializer', VOID, VOID, [KSerializer()]);
    TimeZoneSerializerClass = $;
  }
  return TimeZoneSerializerClass;
}
var TimeZoneSerializer_instance;
function TimeZoneSerializer_getInstance() {
  if (TimeZoneSerializer_instance === VOID)
    new (TimeZoneSerializer())();
  return TimeZoneSerializer_instance;
}
var FixedOffsetTimeZoneSerializerClass;
function FixedOffsetTimeZoneSerializer() {
  if (FixedOffsetTimeZoneSerializerClass === VOID) {
    class $ {
      constructor() {
        FixedOffsetTimeZoneSerializer_instance = this;
        this.h26_1 = PrimitiveSerialDescriptor('kotlinx.datetime.FixedOffsetTimeZone', STRING_getInstance());
      }
      az() {
        return this.h26_1;
      }
      pz(decoder) {
        var zone = Companion_getInstance().d26(decoder.h13());
        if (zone instanceof FixedOffsetTimeZone()) {
          return zone;
        } else {
          throw SerializationException().p10("Timezone identifier '" + zone.toString() + "' does not correspond to a fixed-offset timezone");
        }
      }
      i26(encoder, value) {
        encoder.p14(value.g26());
      }
      oz(encoder, value) {
        return this.i26(encoder, value instanceof FixedOffsetTimeZone() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'FixedOffsetTimeZoneSerializer', VOID, VOID, [KSerializer()]);
    FixedOffsetTimeZoneSerializerClass = $;
  }
  return FixedOffsetTimeZoneSerializerClass;
}
var FixedOffsetTimeZoneSerializer_instance;
function FixedOffsetTimeZoneSerializer_getInstance() {
  if (FixedOffsetTimeZoneSerializer_instance === VOID)
    new (FixedOffsetTimeZoneSerializer())();
  return FixedOffsetTimeZoneSerializer_instance;
}
var UtcOffsetSerializerClass;
function UtcOffsetSerializer() {
  if (UtcOffsetSerializerClass === VOID) {
    class $ {
      constructor() {
        UtcOffsetSerializer_instance = this;
        this.j26_1 = PrimitiveSerialDescriptor('kotlinx.datetime.UtcOffset', STRING_getInstance());
      }
      az() {
        return this.j26_1;
      }
      pz(decoder) {
        return Companion_getInstance_0().l26(decoder.h13());
      }
      m26(encoder, value) {
        encoder.p14(value.toString());
      }
      oz(encoder, value) {
        return this.m26(encoder, value instanceof UtcOffset() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'UtcOffsetSerializer', VOID, VOID, [KSerializer()]);
    UtcOffsetSerializerClass = $;
  }
  return UtcOffsetSerializerClass;
}
var UtcOffsetSerializer_instance;
function UtcOffsetSerializer_getInstance() {
  if (UtcOffsetSerializer_instance === VOID)
    new (UtcOffsetSerializer())();
  return UtcOffsetSerializer_instance;
}
//region block: exports
export {
  FixedOffsetTimeZoneSerializer_getInstance as FixedOffsetTimeZoneSerializer_getInstance1l46ueoee8ix3,
  TimeZoneSerializer_getInstance as TimeZoneSerializer_getInstanceqa9aveo7y5x8,
  UtcOffsetSerializer_getInstance as UtcOffsetSerializer_getInstancehfvjgq5w8o12,
};
//endregion

//# sourceMappingURL=TimeZoneSerializers.mjs.map
